// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { viewBomStyles } from "@stoneage/App/Widgets/ProductDetails/ViewBom";
import { color } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

viewBomStyles.container = {
    css: css`
        background: ${color("common.ui8")};
        display: flex;
        flex-direction: column;
        row-gap: 12px;
        padding: 16px;
    `,
};

viewBomStyles.buttonWrapper = {
    css: css`
        width: 100%;
    `,
};
viewBomStyles.viewButton = {
    typographyProps: {
        css: css`
            &&& {
                text-transform: none;
                font-weight: 500;
            }
        `,
    },
    css: css`
        width: 100%;
        justify-content: center;

        &&& svg {
            stroke-width: 3px;
        }
    `,
};
viewBomStyles.description = {
    color: "common.white",
    variant: "h5",
    forwardAs: "p",
    css: css`
        &,
        p {
            margin-bottom: 0;
        }
    `,
};
viewBomStyles.imageWrapper = {
    css: css`
        width: 100%;
    `,
};
viewBomStyles.image = {
    css: css`
        &,
        img {
            width: 100%;
            height: auto;
        }
    `,
};
viewBomStyles.clickableImg = {
    css: css`
        width: 100%;
    `,
};
